
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";

interface DiscountResultsProps {
  results: any;
  vendorName: string;
}

const DiscountResults = ({ results, vendorName }: DiscountResultsProps) => {
  if (!results || !Array.isArray(results)) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Analysis Results</CardTitle>
          <CardDescription>No results to display</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value);
  };

  const getProfitColor = (profit: number) => {
    return profit >= 0 ? 'text-green-600' : 'text-red-600';
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Analysis Results</CardTitle>
        <CardDescription>Discount analysis for {vendorName}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>SKU</TableHead>
                  <TableHead className="text-right">Final Price</TableHead>
                  <TableHead className="text-right">Profit/Loss</TableHead>
                  <TableHead className="text-right">Margin %</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {results.map((item: any, index: number) => {
                  const profit = item?.profit || 0;
                  const margin = item?.margin || 0;
                  
                  return (
                    <TableRow key={`${item?.SKU || 'unknown'}-${index}`}>
                      <TableCell className="font-medium">
                        {item?.SKU || item?.productSkuID || 'N/A'}
                      </TableCell>
                      <TableCell className="text-right">
                        {formatCurrency(item?.finalPrice || 0)}
                      </TableCell>
                      <TableCell className={`text-right ${getProfitColor(profit)}`}>
                        {formatCurrency(profit)}
                      </TableCell>
                      <TableCell className={`text-right ${getProfitColor(margin)}`}>
                        {margin.toFixed(2)}%
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
          
          <div className="flex justify-end space-x-2">
            <Button variant="outline">Save Configuration</Button>
            <Button>Publish</Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DiscountResults;
